import React from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Fade,
  Modal,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CelebrationIcon from "@mui/icons-material/Celebration";
import { Howl } from "howler";

const gooseImg = process.env.PUBLIC_URL + "/assets/ducks/party-hat.svg";

// Add button click sound instance
const buttonClickSound = new Howl({
  src: ["/assets/audio/click-button.ogg", "/assets/audio/click-button.mp3"],
  volume: 0.4,
});

const EndGameModal = ({
  open,
  onClose,
  moves,
  bestMoves,
  onPlayAgain,
  newBestScore,
}) => {
  const handleClose = () => {
    buttonClickSound.play();
    onClose();
  };

  const handlePlayAgain = () => {
    buttonClickSound.play();
    onPlayAgain();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="endgame-modal-title"
      closeAfterTransition
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Fade in={open} timeout={300}>
        <Box
          sx={{
            position: "relative",
            width: "95%",
            maxWidth: 400,
            bgcolor: "white",
            borderRadius: 3,
            p: { xs: 3, sm: 5 },
            outline: "none",
            textAlign: "left",
            boxShadow: "0 10px 25px rgba(0,0,0,0.18)",
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 16,
              top: 16,
              color: "#888",
              zIndex: 10,
              "&:hover": { bgcolor: "rgba(0,0,0,0.05)" },
            }}
            aria-label="Close"
          >
            <CloseIcon />
          </IconButton>

          <Box
            component="img"
            src={gooseImg}
            alt="Party Goose"
            sx={{
              width: 120,
              height: 120,
              mb: 2,
              mt: 1,
              mx: "auto",
              display: "block",
            }}
          />

          {newBestScore && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: 2,
                animation: "bounce 1s ease infinite",
                "@keyframes bounce": {
                  "0%, 100%": { transform: "translateY(0)" },
                  "50%": { transform: "translateY(-10px)" },
                },
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: "#EC7D60",
                  fontWeight: 800,
                  textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  fontSize: { xs: "1.2rem", sm: "1.4rem" },
                }}
              >
                NEW BEST SCORE! 🎉
              </Typography>
            </Box>
          )}

          <Box sx={{ width: "100%", mt: 1, mb: 2 }}>
            <Typography
              variant="body1"
              sx={{
                color: "#222",
                mb: 0.5,
                fontSize: { xs: "1.15rem", sm: "1.2rem" },
                fontWeight: 700,
                textAlign: "left",
              }}
            >
              Moves: {moves}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#888",
                fontSize: { xs: "1.05rem", sm: "1.1rem" },
                fontWeight: 500,
                textAlign: "left",
              }}
            >
              Your best: {bestMoves}
            </Typography>
          </Box>

          <Button
            variant="contained"
            onClick={handlePlayAgain}
            sx={{
              bgcolor: "#222",
              color: "#fff",
              fontWeight: 700,
              px: 3,
              py: 1.5,
              borderRadius: 3,
              fontSize: { xs: "1.1rem", sm: "1.2rem" },
              mt: 1,
              mb: 0.5,
              boxShadow: "0 2px 8px rgba(0,0,0,0.10)",
              "&:hover": { bgcolor: "#444" },
            }}
          >
            PLAY AGAIN!
          </Button>
        </Box>
      </Fade>
    </Modal>
  );
};

export default EndGameModal;
